"use client";
import * as React from "react";
const SvgCheckRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.94 9.705 1.625 6.39A.951.951 0 1 0 .279 7.737l3.992 3.992a.95.95 0 0 0 1.346 0L15.721 1.626A.951.951 0 1 0 14.374.279L4.94 9.705Z" }));
export {
  SvgCheckRound as default
};
